import { ITypeCurveScaling } from '../../interfaces/itype-curve-scaling';
import { Case } from '../case';
import { TypeCurve } from '../type-curve';

export class TypeCurveScalingBase {
  TypeCurveScalingId: number;
  TypeCurveId: number;
  LateralLengthBasis: number | null;
  BblPerFootBasis: number | null;
  WellSpacingBasis: number | null;
  ParentChildB: number | null;
  ParentChildA: number | null;
  IntrapadSpacingB: number | null;
  IntrapadSpacingA: number | null;
  UpdatedBy: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;
  FracDesignBasis: number | null;
  CaseId: number | null;
  OilFrac: number | null;
  WaterFrac: number | null;

  Case?: Case;
  TypeCurve?: TypeCurve;

  constructor(item?: ITypeCurveScaling) {
    if (item) {

      this.TypeCurveScalingId = item.TypeCurveScalingId;
      this.TypeCurveId = item.TypeCurveId;
      this.LateralLengthBasis = item.LateralLengthBasis;
      this.BblPerFootBasis = item.BblPerFootBasis;
      this.WellSpacingBasis = item.WellSpacingBasis;
      this.ParentChildB = item.ParentChildB;
      this.ParentChildA = item.ParentChildA;
      this.IntrapadSpacingB = item.IntrapadSpacingB;
      this.IntrapadSpacingA = item.IntrapadSpacingA;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;
      this.FracDesignBasis = item.FracDesignBasis;
      this.CaseId = item.CaseId;
      this.OilFrac = item.OilFrac;
      this.WaterFrac = item.WaterFrac;

      this.Case = new Case(item.Case);
      this.TypeCurve = new TypeCurve(item.TypeCurve);
    }
  }
}